import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { RequestService } from '@services/http/request.service';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-chatsidebar2',
  templateUrl: './chatsidebar2.component.html',
  styleUrls: ['./chatsidebar2.component.scss']
})
export class Chatsidebar2Component implements OnInit, OnChanges {
  @Input() isOpen = false;
  @Output() closeSidebarEvent = new EventEmitter<void>();
  
  staffList: any[] = [];
  userType = '';
  vendorId: number | null = null;
  selectedStaffId: number | null = null;
  conversationId: number | null = null;
  showChatBox = false;
  subject = '';
  message = '';
  isSending = false;
  messages: any[] = [];
  loadingMessages = false;
  currentUserId: number | null = null;

  constructor(
    private request: RequestService,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    const userData = this.auth.getUserdata();
    this.userType = userData.user_type;
    this.vendorId = userData.user_id;
    this.currentUserId = userData.user_id;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue === true) {
      this.loadStaffList();
      document.body.style.overflow = 'hidden';
    } else if (changes['isOpen']?.currentValue === false) {
      document.body.style.overflow = '';
    }
  }

  loadStaffList() {
    const params = {
      orderby: '',
      orderto: '',
      page: 1,
      per_page: 10,
      keyword: '',
      alphabetic_search: 'All'
    };
    
    this.request.GET('staff/list', params).subscribe(
      (response: any) => {
        if (response['status']) {
          this.staffList = response['records'] || [];
        }
      },
      (err) => {
        console.error('Error loading staff:', err);
      }
    );
  }

  selectStaff(staff: any) {
    this.selectedStaffId = staff.id;
    this.showChatBox = true;
    this.subject = '';
    this.message = '';
    this.messages = [];
    this.conversationId = null;
    this.loadingMessages = true;
    
    const payload = {
      staff_id: staff.id
    };
    
    this.request.POST('chat/vendor/staff-admin-conversations', payload).subscribe(
      (response: any) => {
        if (response['status'] && response['records'] && response['records'].length > 0) {
          const conversationData = response['records'][0];
          this.messages = conversationData.messages || [];
        }
        this.loadingMessages = false;
      },
      (err) => {
        console.error('Error loading conversation:', err);
        this.loadingMessages = false;
      }
    );
  }

  markConversationAsSeen() {
    if (!this.conversationId) return;
    
    this.request.POST(`chat/conversations/${this.conversationId}/seen`, {}).subscribe(
      (response: any) => {
        const staff = this.staffList.find(s => s.conversation_id === this.conversationId);
        if (staff) {
          staff.seen = true;
          staff.unseen = false;
          staff.unread_count = 0;
        }
      }
    );
  }

  loadMessages() {
    if (!this.conversationId) return;
    
    this.loadingMessages = true;
    this.request.GET(`chat/conversations/${this.conversationId}/messages`, {}).subscribe(
      (response: any) => {
        if (response['status']) {
          this.messages = response['records'] || [];
        }
        this.loadingMessages = false;
      },
      (err) => {
        console.error('Error loading messages:', err);
        this.loadingMessages = false;
      }
    );
  }

  backToList() {
    this.showChatBox = false;
    this.selectedStaffId = null;
    this.conversationId = null;
    this.messages = [];
    this.loadStaffList();
  }

  sendMessage() {
    if (!this.message.trim()) return;
    if (!this.conversationId && !this.subject.trim()) return;

    this.isSending = true;
    
    if (this.conversationId) {
      const payload = {
        conversation_id: this.conversationId,
        message: this.message
      };

      this.request.POST('chat/messages', payload).subscribe(
        (response: any) => {
          this.isSending = false;
          
          if (response['status']) {
            this.messages.push({
              id: Date.now(),
              conversation_id: this.conversationId,
              sender_id: this.currentUserId,
              body: this.message,
              created_at: new Date().toISOString(),
              read_at: null
            });
            
            this.message = '';
          } else {
            alert(response['message'] || 'Failed to send message.');
          }
        },
        (err) => {
          console.error('Error sending message:', err);
          this.isSending = false;
          alert('Failed to send message.');
        }
      );
    } else {
      const payload = {
        subject: this.subject,
        context_type: null,
        context_id: 1,
        message: this.message,
        staff_id: this.selectedStaffId
      };

      this.request.POST('chat/conversations/start', payload).subscribe(
        (response: any) => {
          this.isSending = false;
          
          if (response['status']) {
            if (response['data']?.conversation_id) {
              this.conversationId = response['data'].conversation_id;
            }
            
            this.messages.push({
              id: Date.now(),
              conversation_id: this.conversationId,
              sender_id: this.currentUserId,
              body: this.message,
              created_at: new Date().toISOString(),
              read_at: null
            });
            
            this.subject = '';
            this.message = '';
          } else {
            alert(response['message'] || 'Failed to send message.');
          }
        },
        (err) => {
          console.error('Error sending message:', err);
          this.isSending = false;
          alert('Failed to send message.');
        }
      );
    }
  }

  closeSidebar() {
    document.body.style.overflow = '';
    this.closeSidebarEvent.emit();
  }

  getStaffImage(staff: any): string {
    if (staff.image_name && staff.dir_name) {
      return `https://api.pantheia.com/storage/${staff.dir_name}/${staff.image_name}`;
    }
    return 'assets/images/default-avatar.png';
  }
}
